// src/components/common/NewsSection.js

import React from 'react';
import SourcesList from './SourcesList';
import SectionHeader from './SectionHeader';
import { useSection } from '../../context/SectionContext';
import { marked } from 'marked';

const DEBUG = process.env.NODE_ENV === 'development';

const NewsSection = ({
  title,
  content,
  citations,  // { "1": "url", "2": "url", ... }
  sectionName,
  className = '',
  shareable = true
}) => {
  const { setCurrentSection } = useSection();

  const renderContent = (content, citations) => {
    if (!content) return '';

    try {
      let processedContent = content;
      if (typeof window.processCitations === 'function') {
        processedContent = window.processCitations(processedContent, citations || {});
      }
      return marked.parse(processedContent);
    } catch (error) {
      if (DEBUG) console.error(`Error rendering content for ${sectionName}:`, error);
      return content;
    }
  };

  // Get rendered content first to check if it's empty (e.g., AI refusal was filtered)
  const renderedContent = renderContent(content, citations);

  // Don't render section at all if there's no content
  if (!renderedContent || renderedContent.trim() === '' || renderedContent === '<p></p>\n') {
    return null;
  }

  return (
    <section
      className={`section ${sectionName}-section ${className}`}
      onMouseEnter={() => setCurrentSection(sectionName)}
      onFocus={() => setCurrentSection(sectionName)}
      id={sectionName}
    >
      <div className="section-wrapper">
        {title && (
          <SectionHeader
            title={title}
            sectionName={sectionName}
            content={content}
            shareable={shareable}
          />
        )}

        <div className={`${sectionName}-content section-content`}>
          <div
            className="markdown-content"
            dangerouslySetInnerHTML={{
              __html: renderedContent
            }}
          />
          <SourcesList citations={citations} />
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
